import React, { useState, useEffect, useContext } from "react";
import { Stack, Grid, Group, Text } from "@mantine/core";
import FloatingLabelInput from "./floating-label-input";
import { DataContext } from "../context/DataContext";

const UkAddressInput = ({ onAddressChange, value, ...props }) => {
  const { text, data } = useContext(DataContext);
  const [address, setAddress] = useState({
    addr: data?.addr || "",
    city: data?.city || "",
    state: data?.state || "",
    zip: data?.zip || "",
  });

  // Debug logging removed to prevent loops

  useEffect(() => {
    setAddress({
      addr: data?.addr || "",
      city: data?.city || "",
      state: data?.state || "",
      zip: data?.zip || "",
    });
  }, [data?.addr, data?.city, data?.state, data?.zip]);

  useEffect(() => {
    onAddressChange(address);
  }, [address]);

  const handleInputChange = (field, value) => {
    setAddress((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Logging removed to prevent loops

  return (
    <>
      <Group>
        <Text fz="xs" c="dimmed">
          {text?.general?.address || "Address"}
        </Text>
      </Group>

      <Stack spacing="xs">
        {props.error && (
          <Text fz="xs" c="red">
            Address is required
          </Text>
        )}
        <FloatingLabelInput
          placeholder=""
          label="Street Address"
          value={address.addr}
          onChange={(e) => handleInputChange("addr", e.currentTarget.value)}
        />
        <Grid gutter={8}>
          <Grid.Col span={6}>
            <FloatingLabelInput
              placeholder=""
              label="Town/City"
              value={address.city}
              onChange={(e) => handleInputChange("city", e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <FloatingLabelInput
              placeholder=""
              label="County"
              value={address.state}
              onChange={(e) => handleInputChange("state", e.currentTarget.value)}
            />
          </Grid.Col>
        </Grid>
        <FloatingLabelInput
          placeholder=""
          label="Postcode"
          value={address.zip}
          onChange={(e) => handleInputChange("zip", e.currentTarget.value)}
        />
      </Stack>
    </>
  );
};

export default UkAddressInput;
